import { render, staticRenderFns } from "./index-menu.vue?vue&type=template&id=141e9798&scoped=true"
import script from "./index-menu.vue?vue&type=script&lang=js"
export * from "./index-menu.vue?vue&type=script&lang=js"
import style0 from "./index-menu.vue?vue&type=style&index=0&id=141e9798&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141e9798",
  null
  
)

export default component.exports